module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  sort-event=\"$ctrl.sortEvent\"\n  title=\"Previous Credit Uploads\"\n  resource=\"Credits\"\n  transformer=\"CreditsTransforms\"\n  no-items-text=\"No Credits Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/credits/credits.html
// module id = 1743
// module chunks = 0